import {
  listUsers,
  grantAdmin,
  revokeAdmin,
  resetPassword,
  updateConfig,
} from "../services/Functions";

const listAllUsers = async () => {
  var results = [];
  await listUsers()
    .then((results) => results.data)
    .then((listUsersResult) => {
      listUsersResult.forEach((doc) => {
        doc.customClaims = Object.keys(doc.customClaims || {});
        results.push(doc);
      });
    })
    .catch((error) => {
      console.log("Error getting users: ", error);
    });

  return results;
};

const setUserIsAdmin = async (uid, isAdmin) => {
  let req = isAdmin ? grantAdmin : revokeAdmin;
  return req({ uid: uid })
    .then((result) => console.log)
    .catch((error) => console.error(error.message));
};

const resetPasswordForUser = async (email) => {
  return resetPassword({ email: email });
};

const updateConfigValue = async (key, value) => {
  return updateConfig({ key, value })
    .then((result) => result.data)
    .catch((error) => console.error(error.message));
};

const UserService = {
  listAllUsers,
  setUserIsAdmin,
  resetPasswordForUser,
  updateConfigValue,
};

export default UserService;
